import { render, staticRenderFns } from "./ArchiveOrder.vue?vue&type=template&id=6fdaf398&scoped=true&"
import script from "./ArchiveOrder.vue?vue&type=script&lang=js&"
export * from "./ArchiveOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdaf398",
  null
  
)

export default component.exports